import { FunctionComponent, ReactElement } from "react";
import ModalOpen from "./modalExportar/components/modal";
import FilterListIcon from '@mui/icons-material/FilterList';

interface ModalFiltroProps {
  children?: ReactElement | ReactElement[]
}

const ModalFiltro: FunctionComponent<ModalFiltroProps> = ({ children }) => {
  return (<ModalOpen
    title="Filtros"
    buttonStyle={{
      sx: {
        boxShadow: 'none',
        '@media (max-width: 600px)': {
          '> p': {
            display: 'none'
          }
        }
      },

      startIcon: <FilterListIcon />,
      variant: 'contained'
    }}
  >
    {
      children
    }
  </ModalOpen>);
}

export default ModalFiltro;
